<ng-container *ngIf="page">
  <header>
    <app-logo [height]="28"></app-logo>
  </header>

  <section class="container">
    <div class="col-span-12" [innerHtml]="page.content | safeHtml"></div>
  </section>
</ng-container>
